import React from "react";

const ContactMarquee = () => {
  return (
    <div>
      <marquee
        className="text-center py-3 contact-info1"
        style={{
          backgroundColor: "#1e1c42",
          color: "#fff",
          fontSize: "20px",
          fontWeight: "normal",
          overflowX: "hidden",
        }}
        aria-label="Contact Information for Columbiaa Hospital"
        title="Contact Columbiaa Hospital for Appointments, Enquiries, and Emergency Services"
        behavior="scroll"
        direction="left"
        scrollamount="10"
        // initialdelay="5000"
      >
        <span
          className="hide-on-mobile"
          aria-label="Contact Us for More Details at Columbiaa Hospital"
          title="Contact Columbiaa Hospital for More Information"
          style={{ fontWeight: "normal" }}
        >
          Contact Us for More Details:
        </span>
        <a
          href="tel:08044484444"
          className="ml-2"
          style={{ color: "#fff", textDecoration: "none", fontWeight: "normal" }}
          title="Call for Appointments at Columbiaa Hospital"
          aria-label="Call Columbiaa Hospital for Appointments on 080 4448 4444"
        >
          Appointments: 080 4448 4444 |
        </a>
        <a
          href="tel:08040939899"
          className="ml-2"
          style={{ color: "#fff", textDecoration: "none", fontWeight: "normal" }}
          title="Call for Enquiries at Columbiaa Hospital"
          aria-label="Call Columbiaa Hospital for Enquiries on 080 4093 9899"
        >
          Enquiry: 080 4093 9899 |
        </a>
        <a
          href="tel:+918548979899"
          className="ml-2"
          style={{ color: "#fff", textDecoration: "none", fontWeight: "normal" }}
          title="Call Columbiaa Hospital Emergency Number"
          aria-label="Call Columbiaa Hospital for Emergency on +91 85489 79899"
        >
          Emergency: +91 85489 79899
        </a>
      </marquee>
    </div>
  );
};

export default ContactMarquee;
